module.exports = __webpack_public_path__ + "img/19.06f0a034.jpg";